import RequireRole from "./RequireRole";

export default RequireRole;
